export default "__VITE_ASSET__C5ZJd8Iq__"